import React from 'react';

const SIGILS = {
  stream: { prefix: '/', color: 'var(--bujo-token-stream)' },
  project: { prefix: '#', color: 'var(--bujo-token-project)' },
  context: { prefix: '@', color: 'var(--bujo-token-context)' }
};

/** A /stream, #project or @context reference. The sigil is the information; colour is a mnemonic. */
export function TokenPill({ kind = 'stream', name, bordered = false, size = 'meta', style }) {
  const s = SIGILS[kind] || SIGILS.stream;
  const fs = size === 'entry' ? 'var(--bujo-fs-entry)' : 'var(--bujo-fs-meta)';
  return (
    <span style={{
      font: `var(--bujo-fw-regular) ${fs}/var(--bujo-lh-tight) var(--bujo-font-mono)`,
      color: s.color,
      ...(bordered ? {
        border: '1px solid var(--bujo-rule-hairline)',
        padding: '5px 7px',
        display: 'inline-block'
      } : null),
      ...style
    }}>{s.prefix}{name}</span>
  );
}
